import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { formatPageTitle } from "../../utils/commonFunctions";
import { Col, Row } from "react-bootstrap";
import LeadsDetailsHeader from "../components/LeadsDetailsHeader";
import UserEngagementTimeline from "../components/UserEngagementTimeline";
import {
  useGetProjectDetails,
  useGetSummaryLeadsUserDetails,
  useGetSummaryLeadsUserEngagement,
} from "../../../../../../queries/query-hooks/workspace/emsl-hook";
import UserDetailsHeaderSkeleton from "../../../../../../skeleton/workspace/clirnet/emsl/userDetailsHeader-skeleton";
import UserTimelineSkeleton from "../../../../../../skeleton/workspace/clirnet/emsl/userTimeline-skeleton";
import { ProjectHeaderTopBar, CardNotFound } from "@ui";

const LeadsDetails = () => {
  const { project_id, page_title, leads_id } = useParams();
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id, true);

  const contentIds = projectDetails?.content
    ?.map((item) => item?.content_id)
    .join(",");
  const payload = {
    start_date: projectDetails?.project_start_date,
    end_date: projectDetails?.project_end_date,
    content_id: contentIds,
  };

  const { data: leadsUserData, isLoading: isLeadsUserDataLoading } =
    useGetSummaryLeadsUserDetails(project_id, leads_id, payload);
  const { data: leadsUserEngagement, isLoading: isLeadsUserEngagementLoading } =
    useGetSummaryLeadsUserEngagement(project_id, leads_id, payload);

  const pageTitle = formatPageTitle(page_title);

  return (
    <div>
      <ProjectHeaderTopBar
        projectType="eMSL"
        title={pageTitle}
        projectStartDate={projectDetails?.project_start_date || ""}
        projectEndDate={projectDetails?.project_end_date || ""}
        status={projectDetails?.status}
        isProjectDetailsLoading={isProjectDetailsLoading}
      />

      <Row className="mb-3">
        <Col md={12}>
          {!isLeadsUserDataLoading && Object.keys(leadsUserData).length > 0 ? (
            <LeadsDetailsHeader leadsUserData={leadsUserData} />
          ) : isLeadsUserDataLoading ? (
            <UserDetailsHeaderSkeleton />
          ) : (
            <CardNotFound />
          )}
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          {!isLeadsUserEngagementLoading &&
          Array.isArray(leadsUserEngagement) &&
          leadsUserEngagement?.length > 0 ? (
            <UserEngagementTimeline
              title="User Engagement"
              leadsUserEngagement={leadsUserEngagement}
              engagementPayload={payload}
            />
          ) : isLeadsUserEngagementLoading ? (
            <UserTimelineSkeleton title="User Engagement" />
          ) : (
            <CardNotFound title="User Engagement" />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LeadsDetails;
